import { Box, Button, IconButton, Divider, Tooltip, Badge } from '@mui/material'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";

const TestRunActions = ({
  testCase,
  handleRunTestCase,
  handleOpenDeleteDialog,
  handleFeedbackClick,
  isFeedbackPending = false,
}) => {
  const isLikeActive = testCase?.my_feedback === 1;
  const isDislikeActive = testCase?.my_feedback === -1;

  return (
    <Box className="testRunActions">
      { testCase?.isActive ?
        <>
          <Box className="testRunActionButtonsContainer">
            <Tooltip title={isLikeActive ? "Remove like" : "Like"}>
              <span>
                <IconButton
                  className={`testRunFeedbackButton ${isLikeActive ? "isActive" : ""}`}
                  onClick={(event) => handleFeedbackClick(event, 1)}
                  disabled={isFeedbackPending}
                >
                  <Badge
                    badgeContent={Number(testCase?.likes_count) || 0}
                    color="primary"
                    max={99}
                    showZero
                  >
                    <ThumbUpAltOutlinedIcon
                      color={isLikeActive ? "primary" : "action"}
                      fontSize="small"
                    />
                  </Badge>
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title={isDislikeActive ? "Remove dislike" : "Dislike"}>
              <span>
                <IconButton
                  className={`testRunFeedbackButton ${isDislikeActive ? "isActive isNegative" : ""}`}
                  onClick={(event) => handleFeedbackClick(event, -1)}
                  disabled={isFeedbackPending}
                >
                  <Badge
                    badgeContent={Number(testCase?.dislikes_count) || 0}
                    color="error"
                    max={99}
                    showZero
                  >
                    <ThumbDownAltOutlinedIcon
                      color={isDislikeActive ? "error" : "action"}
                      fontSize="small"
                    />
                  </Badge>
                </IconButton>
              </span>
            </Tooltip>
            <Button
              id='rerunTestRunButton'
              className="rerunButton"
              variant="contained"
              color="secondary"
              onClick={handleRunTestCase}
            >
              RE-RUN
            </Button>
          </Box>
          <Divider orientation="vertical" flexItem/>
        </> : null
      }
      <IconButton className="testRunActionsDeleteIconButton" onClick={handleOpenDeleteDialog}>
        <DeleteOutlineOutlinedIcon color='error' />
      </IconButton>
    </Box>
  )
}

export default TestRunActions
